import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { GroupReportScreen } from '@/features/group-reports/group-report-screen'
import {
  type GroupReportSearch,
  groupReportSearchFrom,
} from '@/features/group-reports/group-report-search'
import { GROUP_REPORT_PERMISSION, getCompanyReach } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/group/reports/balance-sheet')({
  validateSearch: (search: Record<string, unknown>): GroupReportSearch =>
    groupReportSearchFrom(search),
  beforeLoad: ({ context }) => {
    // A direct visit with less than two active reachable companies is an
    // intentional no-reach state, not a redirect. The report hook stays
    // disabled from the same cached /me-derived reach.
    getCompanyReach(context.queryClient, GROUP_REPORT_PERMISSION)
  },
  component: BalanceSheetRoute,
})

function BalanceSheetRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()
  return (
    <GroupReportScreen
      {...{
        report: 'balance-sheet' as const,
        search,
        onSearchChange: (next: GroupReportSearch) =>
          void navigate({ to: '/group/reports/balance-sheet', search: next }),
      }}
    />
  )
}
